import { KpiInstance, MesInstance } from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  KpiApiKpiCapacityUtilizationGetRequest,
  KpiApiKpiDefectRateGetRequest,
  KpiApiKpiElectricPowerGetRequest,
  KpiApiKpiLeadTimeGetRequest,
  KpiApiKpiManHourCostGetRequest,
  KpiApiKpiOrderLeadTimeGetRequest,
  KpiApiKpiUphGetRequest,
  MesApiAuditKpiGetRequest,
} from "@sizlcorp/sizl-api-document/dist/models";

export const KPI = createQueryKeys("kpi", {
  all: null,
  leadTime: (params: KpiApiKpiLeadTimeGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiLeadTimeGet(params),
    };
  },
  manhour: (params: KpiApiKpiManHourCostGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiManHourCostGet(params),
    };
  },
  defectRate: (params: KpiApiKpiDefectRateGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiDefectRateGet(params),
    };
  },
  UPH: (params: KpiApiKpiUphGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiUphGet(params),
    };
  },
  leadTimeOrder: (params: KpiApiKpiOrderLeadTimeGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiOrderLeadTimeGet(params),
    };
  },
  powerUsage: (params: KpiApiKpiElectricPowerGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiElectricPowerGet(params),
    };
  },
  rateOfOperation: (params: KpiApiKpiCapacityUtilizationGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => KpiInstance.kpiCapacityUtilizationGet(params),
    };
  },
  auditKPI: (params: MesApiAuditKpiGetRequest) => {
    if (params) {
      const query: any = {};
      // query를 보내는 조건은 필터 검색을 할 때이다.
      if (params.query.$and.length > 0) {
        query["query"] = JSON.stringify(params.query);
      }
      params = { ...params, ...query };
    }
    return {
      queryKey: [params],
      queryFn: () => MesInstance.auditKpiGet(params),
    };
  },
});
